import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Actions } from "../Actions/Actions";
import styles from "../styles.module.scss";
import { freightData, FreightRow } from "./utils";
import { Pencil, Trash2 } from "lucide-react";

interface FreightTableProps {
  onEdit: (shipment: FreightRow) => void;
  onDelete: (shipment: FreightRow) => void;
}

const FreightTable: React.FC<FreightTableProps> = ({ onEdit, onDelete }) => {
  const freightColumns: ColumnsType<FreightRow> = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Supplier Name", dataIndex: "supplierName", key: "supplier" },
    { title: "Freight Name", dataIndex: "freightName", key: "freight" },
    { title: "Type", dataIndex: "type", key: "type" },

    {
      title: "Default lead time",
      dataIndex: "defaultLeadTime",
      key: "lead",
      align: "right",
    },
    {
      title: "Minimum weight",
      dataIndex: "minWeight",
      key: "minW",
      align: "right",
    },
    {
      title: "Minimum volumetric weight",
      dataIndex: "minVolWeight",
      key: "minVol",
      align: "right",
    },

    { title: "Size type", dataIndex: "sizeType", key: "size" },
    { title: "Region", dataIndex: "region", key: "region" },
    { title: "Loading type", dataIndex: "loadingType", key: "loading" },

    {
      title: "Cost per pound",
      dataIndex: "costPerPound",
      key: "cpp",
      align: "right",
      render: (v) => `£${v.toFixed(2)}`,
    },
    {
      title: "Cost per volume",
      dataIndex: "costPerVolume",
      key: "cpv",
      align: "right",
      render: (v) => `£${v.toFixed(2)}`,
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      render: (_: unknown, row: FreightRow) => (
        <Actions
          record={row}
          actions={[
            {
              icon: <Pencil />,
              onClick: onEdit,
            },
            {
              icon: <Trash2 />,
              onClick: onDelete,
            },
          ]}
        />
      ),
    },
  ];
  return (
    <Table
      columns={freightColumns}
      dataSource={freightData}
      pagination={{ pageSize: 10 }}
      rowKey="key"
      scroll={{ x: 100 }}
      className={styles.table}
    />
  );
};

export default FreightTable;
